import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import AddRatesWizard from '../../generic-components/add-rates-wizard/add-rates-wizard';

const AddRates = ({
  onRequestClose,
  contractId,
  productId,
  productName,
  existingSeasons,
  saveProductInfoChanges,
  productType,
  contractingPeriod,
  openGlobalAlert,
}) => {
  return (
    <div>
      <AddRatesWizard
        contractingPeriod={contractingPeriod}
        productType={productType}
        productName={productName}
        existingSeasons={existingSeasons}
        cancelText="Cancel"
        cancelFunc={() => {
          openGlobalAlert({
            text: 'You will lose all the data you just entered if you cancel now. Are you sure you want to cancel?',
            onOk: onRequestClose,
          });
        }}
        continueText="Save season"
        saveProductInfoChanges={seasonRates => saveProductInfoChanges({ seasonRates, productId, contractId, updateType: 'SEASONRATES_SAVED_TO_DB' })}
      />
    </div>
  );
};

const mapStateToProps = ({ user, contracting }) => ({
  productType: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productType'])
  || contracting.contractActivitiesProducts.getIn(['leftNav', 'productType']) || user.getIn(['company', 'productType']),
});

AddRates.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  data: PropTypes.object,
  savingRates: PropTypes.func,
  productName: PropTypes.string,
  contractingPeriod: PropTypes.object,
  openGlobalAlert: PropTypes.func,
};

const mapActions = ({
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
});
export default connect(mapStateToProps, mapActions)(AddRates);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/add-more-rates.jsx